import React from 'react';
import logoExpressojk from '../../../estilo/comum/img/logo_expressojk.webp';
import iconExpressoJK from '../../../estilo/comum/img/icon/expressojk.ico';
import bannerAgenciaMobile from '../../../estilo/comum/img/banner-site-expressojk-mobile.png';
import bannerAgenciaMobile2 from '../../../estilo/comum/img/banner-site-expressojk-mobile-2.png';
import cardPrecoPromocao from '../../../estilo/comum/img/carouselCards/12.webp';
import cardContrateVexado from '../../../estilo/comum/img/carouselCards/17.webp';
import cardModalPromocao from '../../../estilo/comum/img/carouselCards/cupomDescontoAgencias.webp';
import cardQueroAgencia from '../../../estilo/comum/img/carouselCards/18.webp';

const logoExpressoJKRodape = <img src={logoExpressojk} alt="Logo Agência" style={{width: '234px', quality: 'auto'}}/>;
const logoExpressoJKCabecalho = <img className="logo-site" src={logoExpressojk} alt='Logo Agência' style={{quality: 'auto'}}/>;


export const dadosExpressojkConfig = {    
    id: 'expressojk',
    pastaEstilo: 'expressojk',    
    nome: 'Expresso JK',    
    instagram: 'https://www.instagram.com/expressojk/',
    facebook: 'https://www.facebook.com/Expressojktransportes/',
    youtube: 'youtube.com',
    email: 'sac@expressojk.com.br',
    logo: logoExpressojk,
    logoCabecacho: logoExpressoJKCabecalho,
    logoRodape: logoExpressoJKRodape,
    icone: iconExpressoJK,
    imgMobile: bannerAgenciaMobile,
    imgMobile2: bannerAgenciaMobile2,    
    nomePrefixo: 'o Expresso JK',    
    sacAtendimento: '08000 023 1212',
    lkSacAtendimneto: 'tel:080000231212',
    telefone: '(61) 93500-6245',
    wtpp: '(61) 935006245',
    lktelefone: 'tel:5561935006245',
    lkemail: 'mailto:sac@expressojk.com.br',
    lkemailSuporte: 'mailto:sac@expressojk.com.br',
    lkwhats: 'https://api.whatsapp.com/send?phone=5561935006245&text=Olá. Preciso de atendimento.',    
    OgImage: 'https://imagens-open-graph-sites-agencias.s3.amazonaws.com/agencias/sites+agencias.webp',    
    quemSomos: '',
    videoInicio: null,    
    bannerModalPromocao: null,
    cardPrecoPromocao: cardPrecoPromocao,
    cardContrateVexado: cardContrateVexado,
    cardModalPromocao: cardModalPromocao,
    cardQueroAgencia: cardQueroAgencia,    
    banner: null,
    bannerMobile: null,    
    tiktok: 'https://www.tiktok.com/@vexadoo',    
    distribusion: false,
    exibePopUpPromocao: false,
    urlBase: 'https://expressojk.com.br',
    idsTagManager: ['GTM-MCV3NTB']
};
